import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import DateRangeComponent from "../DateRangeComponent";
import {
  fetchPCClassificationsLogic,
  fetchPCMediaLogic,
  fetchPatientPCLogic,
  clearPinnedContent,
} from "../../../../../store/features/patient/pinnedContentSlice";
import { ReactComponent as PinIcon } from "../../../../../assets/icons/pin.svg";
import PinnedContentTable from "./PinnedContentTable.js";
import PatientLoader from "../../../../common/PatientLoader";
import axiosInstance, { CMS_BASE_URL } from "../../../../../axios";
import PinnedPieChart from "./PinnedPieChart";
import PinnedBarChart from "./PinnedBarChart";
import PinNewContent from "./PinNewContent";
import PinNewContentV2 from "./PinNewContentV2.js";
const PinnedContent = (props) => {
  const dispatch = useDispatch();
  const [isModalOpen, setModalOpen] = useState(false);
  const [formattedData, setFormattedData] = useState([]);
  const [data, setData] = useState([]);
  const { loading, singlePatientData } = useSelector((state) => state.patient);
  const { patientPinnedContent, pinnedContentLoading } = useSelector(
    (state) => state.pinnedContent
  );
  useEffect(() => {
    if (!loading && singlePatientData?.id) {
      dispatch(clearPinnedContent()); // Clear the state first
      dispatch(fetchPatientPCLogic(singlePatientData?.id));
    }
  }, [loading, singlePatientData?.id, dispatch]);

  const curatePinnedContent = async (category, ids) => {
    const res = await axiosInstance.get(`${CMS_BASE_URL}/${category}`, {
      params: { id_in: ids },
    });
    return { [category]: res?.data };
  };
  useEffect(() => {
    if (patientPinnedContent && patientPinnedContent.length > 0) {
    handlePinnedContentFormatting();
    }
    // return ()=>dispatch(clearPinnedContent());
  }, [patientPinnedContent]);

  useEffect(() => {
    return ()=>dispatch(clearPinnedContent());
  },[ ]);

  const handlePinnedContentFormatting = async () => {
    const CATEGORY_LOOKUP = {
      Videos: "view-medicas",
      ViewMedica: "view-medicas",
      Article: "posts",
      Audio: "audios",
      TikToks: "tik-toks",
    };
    const hashmap = {};
    const timestamps = {};

    // patientPinnedContent.length > 0 &&
      patientPinnedContent?.forEach((element) => {
        const category = CATEGORY_LOOKUP[element?.type];
        timestamps[element?.identifier] = element?.modified;
        if (category in hashmap) {
          hashmap[category].push(element.identifier);
        } else {
          hashmap[category] = [element.identifier];
        }
      });

    const final = [];
    let unformatted = [];
     for (const [key, value] of Object.entries(hashmap)) {
      let temp = await curatePinnedContent(key, value);
      unformatted = unformatted.concat([...temp[key]]);
      final.push(temp);
    }
    unformatted = unformatted
      .map((item) => {
        item["pinned_at"] = timestamps[item?.id];
        return item;
      })
      .sort((a, b) => {
        const dateA = new Date(a.pinned_at);
        const dateB = new Date(b.pinned_at);
        return dateA - dateB; // Compare in descending order
      });

    if( patientPinnedContent.length > 0){
      setFormattedData(final);
      setData(unformatted);
    }
    else {
      setFormattedData([]);
      setData([]);
    }
   
  };



  return (
    <div className="container-fluid" style={{ margin: "0px", padding: "0px" }}>
      {/* <DateRangeComponent /> */}
      <div className="row px-3">
        <PinnedPieChart
          title="By Category"
          patientPinnedContent={data}
          pinnedContentLoading={pinnedContentLoading}
        />
        <PinnedBarChart
          title="By Content Format"
          patientPinnedContent={patientPinnedContent}
          pinnedContentLoading={pinnedContentLoading}
        />
      </div>

      <CardLayout
        className="col-sm-12 col-md-12 col-lg-12"
        style={{
          border: "8px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        <div className="container-fluid px-4 pb-4">
          <PinNewContentV2 patientID={props?.id} />
        </div>
      </CardLayout>
      <CardLayout
        className="col-sm-12 col-md-12 col-lg-12"
        style={{
          border: "8px solid transparent",
          boxSizing: "border-box",
          backgroundClip: "padding-box",
        }}
      >
        <PinNewContent
          modalIsOpen={isModalOpen}
          setModalOpen={setModalOpen}
          patientID={props?.id}
        />
        <div className="container-fluid d-flex mt-2 justify-content-between">
          <label style={{ fontSize: "1.3rem" }}>All Pinned Content</label>
          {/* /**hidden this button for now.*/ }
          {/* <button
            className="primary-btn"
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <PinIcon /> Pin New Content
          </button> */}
        </div>

        <div className="container-fluid px-4 pb-4">
          {pinnedContentLoading ? (
            <PatientLoader />
          ) : (
            <PinnedContentTable data={data} setFormattedData={setFormattedData} setData={setData}/>
          )}
        </div>
      </CardLayout>
    </div>
  );
};
export default PinnedContent;
